module.exports = __webpack_public_path__ + "static/media/logoFooterSPRegula.9ce28c0e.png";